import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import { theme } from '../../../Layout/theme';
import { colors } from '../../../Constants/constants';
import AppButton from '../../../Layout/AppButton';

interface ICategoryButtonsProps {
	selectedCategory: string;
	onClickFirstButton: () => void;
	onClickSecondButton: () => void;
}

const useStyles = makeStyles((theme) => ({
	categoryButtons: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		marginTop: '15px',
		marginBottom: '15px',
		overflow: 'visible',
		margin: '0 15px',
		[theme.breakpoints.down(570)]: {
			margin: '15px 0 0 0',
		},
		[theme.breakpoints.down(460)]: {
			flexDirection: 'column',
		},
	},
}));

export const CategoryButtons = (props: ICategoryButtonsProps) => {
	const { t } = useTranslation();
	const { selectedCategory, onClickFirstButton, onClickSecondButton } = props;
	const classes = useStyles();

	const donationsListLabel: string = `${t('report.DonationReport')}`;
	const vouchersListLabel: string = `${t('report.voucherReport')}`;
	const isMobile = useMediaQuery(theme.breakpoints.down(1010));

	const appButtonStyle = {
		fontWeight: 'bold',
		fontSize: isMobile ? '19px' : '24px',
		lineHeight: '28px',
		textTransform: 'unset',
		boxShadow: 'none',
	};

	return (
		<div className={classes.categoryButtons}>
			<div>
				<AppButton
					color={selectedCategory === donationsListLabel ? colors.barPanelSelectItemColor : '#ffffff'}
					onClick={() => onClickFirstButton()}
					icon={null}
					label={donationsListLabel}
					variant='contained'
					style={
						selectedCategory === donationsListLabel
							? appButtonStyle
							: {
									...appButtonStyle,
									color: 'rgba(66, 66, 66, 0.4)',
							  }
					}
				/>
			</div>
			<div style={{ marginLeft: '20px' }}>
				<AppButton
					color={selectedCategory === vouchersListLabel ? colors.barPanelSelectItemColor : '#ffffff'}
					onClick={() => onClickSecondButton()}
					icon={null}
					label={vouchersListLabel}
					variant='contained'
					style={
						selectedCategory === vouchersListLabel
							? appButtonStyle
							: {
									...appButtonStyle,
									color: 'rgba(66, 66, 66, 0.4)',
							  }
					}
				/>
			</div>
		</div>
	);
};
